import { Auth, ExpiredAuthSessionError } from '#auth/runtime'
import { defineNuxtPlugin, useRuntimeConfig } from '#imports'
import { defu } from 'defu';

// Active schemes
import { Oauth2Scheme } from '#auth/runtime'

// Options
let options = {
    "globalMiddleware": false,
    "enableMiddleware": true,
    "resetOnError": false,
    "resetOnResponseError": false,
    "ignoreExceptions": false,
    "scopeKey": "scope",
    "rewriteRedirects": true,
    "fullPathRedirect": true,
    "redirectStrategy": "query",
    "watchLoggedIn": true,
    "tokenValidationInterval": false,
    "redirect": {
        "login": "\u002Flogin",
        "logout": "\u002Flogout",
        "home": "\u002F",
        "callback": "\u002Fcallback"
    },
    "stores": {
        "state": {
            "namespace": "auth"
        },
        "pinia": {
            "enabled": false,
            "namespace": "auth"
        },
        "cookie": {
            "enabled": true,
            "prefix": "auth.",
            "options": {
                "path": "\u002F",
                "sameSite": "lax",
                "maxAge": 31536000
            },
            "secure": true
        },
        "local": {
            "enabled": false,
            "prefix": "auth."
        },
        "session": {
            "enabled": false,
            "prefix": "auth."
        }
    },
    "defaultStrategy": "azuread",
    "routerStrategy": "navigateTo"
}

export default defineNuxtPlugin({
    name: 'nuxt-alt:auth',
    async setup(nuxtApp) {
        // Create a new Auth instance
        const auth = new Auth(nuxtApp, options)

        // Register strategies
        auth.registerStrategy('azuread', new Oauth2Scheme(auth, defu(useRuntimeConfig()?.public?.auth?.strategies?.['azuread'], {"endpoints":{"authorization":"https://teljoypaystg.b2clogin.com/teljoypaystg.onmicrosoft.com/B2C_1_TELJOY_PAY_STG/oauth2/v2.0/authorize","token":"https://teljoypaystg.b2clogin.com/teljoypaystg.onmicrosoft.com/B2C_1_TELJOY_PAY_STG/oauth2/v2.0/token","logout":"https://teljoypaystg.b2clogin.com/teljoypaystg.onmicrosoft.com/B2C_1_TELJOY_PAY_STG/oauth2/v2.0/logout","user":"https://graph.microsoft.com"},"token":{"property":"access_token","type":"Bearer","maxAge":1800},"refreshToken":{"property":"refresh_token","maxAge":2592000},"responseType":"token","grantType":"authorization_code","clientId":"89d153b8-2524-4fb5-ac40-ebc7f85a1e7a","scope":["openid","profile","email","https://teljoypaystg.onmicrosoft.com/89d153b8-2524-4fb5-ac40-ebc7f85a1e7a/user.read"],"state":"g-7FZG8V_f9LAi6s4dL4k3kgUEetEGdwei6ZAuixwvC!BPLozr","codeChallengeMethod":"","responseMode":"","acrValues":"","name":"azuread","ssr":true})))

        nuxtApp.provide('auth', auth)

        return auth.init()
        .catch(error => {
            if (process.client) {
                // Don't console log expired auth session errors. This error is common, and expected to happen.
                // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
                // token. We don't want to log this as an error.
                if (error instanceof ExpiredAuthSessionError) {
                    return
                }

                console.error('[ERROR] [AUTH]', error)
            }
        })
    }
})